import useSWR from 'swr'
import { Group } from 'domain/models/Group/EntityGroup'
import { apiClient } from 'services/api/client'

export const useGetGroupBySlug = ({ slug }: { slug?: string }) => {
  const key = slug ? `/groups/${slug}` : null
  const fetcher = () =>
    apiClient.get<Group | null>(`/groups/${slug}`).then((res) => res.data)
  return useSWR(key, fetcher)
}
